import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop.jsx";
// Component import
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import FooterLast from "./components/Footer/FooterLast.jsx";
// Page import
import Home from "./pages/Home/Home.jsx";
import Homeslider from "./pages/Home/Homeslider.jsx";
import SliderHome from "./pages/Home/SliderHome.jsx";
import About from "./pages/About/About.jsx";
import Services from "./pages/Services/Services.jsx";
import Products from "./pages/Products/Products.jsx";
import Contact from "./pages/Contact/Contact.jsx";
import ContactForm from "./pages/Contact/ContactForm.jsx";
import Contactmap from "./pages/Contact/Contactmap.jsx";
import ContactPage from "./pages/Contact/ContactPage.jsx";


function App() {
    //work branch mobile için son hali
    return (
        <Router>
            <ScrollToTop/>
            <div className="App">
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<SliderHome />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/contact" element={<ContactPage />} />
                    </Routes>
                </main>
            </div>
            <Footer />
        </Router>
    );
}

export default App;
